// removed by extract-text-webpack-plugin
module.exports = {"right":"related-views-button__right___1mr6A"};